import service from './request.js'

export default {
  //获取网站首页 导航栏目
  GetParentSiteChannel(data){
    return service({
        url: 'SiteWebApi/GetParentSiteChannel',
        method: 'get',
        params: data
    })
  },
  //获取网站首页 子级导航栏目
  GetChildSiteChannel(data){
    return service({
        url: 'SiteWebApi/GetChildSiteChannel',
        method: 'get',
        params: data
    })
  },
  //每期快报 获取当期 期刊信息
  GetCurrentPeriod(data){
    return service({
        url: 'SiteWebApi/GetCurrentPeriod',
        method: 'get',
        params: data
    })
  },
  //过刊浏览目录
  GetYearVolumeTree(data){
    return service({
        url: 'SiteWebApi/GetYearVolumeTree',
        method: 'get',
        params: data
    })
  },
  //获取首页期刊 排行类型 分页列表数据
  GetJournalArticleList(data){
    return service({
        url: 'SiteWebApi/GetJournalArticleList',
        method: 'post',
        data
    })
  },
  //过刊浏览页 当年的年卷期和封面
  GetThatYearIssueList(data){
    return service({
        url: 'SiteWebApi/GetThatYearIssueList',
        method: 'get',
        params: data
    })
  },
  //过刊浏览页 获取杂志社的间隔年限
  GetJournalGapYear(data){
    return service({
        url: 'SiteWebApi/GetJournalGapYear',
        method: 'get',
        params: data
    })
  },
  //过刊浏览页 获取杂志社的年限
  GetJournalYear(data){
    return service({
        url: 'SiteWebApi/GetJournalYear',
        method: 'get',
        params: data
    })
  },
  //过刊浏览页 获取杂志社的年限下的所出期刊数
  GetJournalIssueList(data){
    return service({
        url: 'SiteWebApi/GetJournalIssueList',
        method: 'get',
        params: data
    })
  },

  //获得过期总页
  GetGuoqiData(data){
    return service({
        url: 'JournalInfoApi/GetYearVolumeTree',
        method: 'get',
        params: data
    })
  },
  
  //获取过刊浏览 列表数据
  GetBackIssueBrowsing(data){
    return service({
        url: 'SiteWebApi/GetBackIssueBrowsing',
        method: 'post',
        data
    })
  },
  //获取过刊浏览 列表数据
  GetHomePageBlockInfo(data){
    return service({
        url: 'SiteWebApi/GetHomePageBlockInfo',
        method: 'post',
        data
    })
  },
  //获取内容详情,带有 上一条和下一条的标题信息
  GetContentInfo(data){
    return service({
        url: 'SiteWebApi/GetContentInfo',
        method: 'post',
        data
    })
  },



  //获取视频/课件 (特殊使用)
  GetVideoCourseware(data){
    return service({
        url: 'SiteWebApi/GetVideoCourseware',
        method: 'get',
        params: data
    })
  },
  //网站搜索
  GetSiteSearch(data){
    return service({
        url: 'SiteWebApi/GetSiteSearch',
        method: 'post',
        data
    })
  },
  //文件下载
  GetContentFilePath(data){
    return service({
        url: 'SiteWebApi/GetContentFilePath',
        method: 'get',
        params: data
    })
  },
  //轮播图
  GetHomePagePicture(data){
    return service({
        url: 'SiteWebApi/GetHomePagePicture',
        method: 'post',
        data
    })
  },
  //获取网站访问量
  GetSiteAccessCount(data){
    return service({
        url: 'SiteWebApi/GetSiteAccessCount',
        method: 'post',
        data
    })
  },
  //更新点击量
  GetGotoFilePath(data){
    return service({
        url: 'SiteWebApi/GetGotoFilePath',
        method: 'get',
        params: data
    })
  },
}



// WEBPACK FOOTER //
// ./src/utils/api.js